import { DeepPartial, ResultsSuggestionsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RESULTS_SUGGESTIONS: DeepPartial<ResultsSuggestionsConfig> = { components: { container: 'CdlSuggestions' }, size: 6 };
